var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleUnderscore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000087407417885255811370000008441415238938073786_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.7 1.7",
    style: {
      enableBackground: "new 0 0 147.7 1.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4CE8F2;}\r\n\t.st1{fill:#34A0D9;}\r\n\t.st2{fill:#0070C0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000025442341519708309710000004998945167959663007_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.1,1.7H0.9C0.4,1.7,0,1.3,0,0.9S0.4,0,0.9,0h110.2c0.5,0,0.9,0.4,0.9,0.9S111.5,1.7,111.1,1.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,1.7h-15.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H134c0.5,0,0.9,0.4,0.9,0.9S134.5,1.7,134,1.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.8,1.7h-7.2c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h7.2c0.5,0,0.9,0.4,0.9,0.9S147.3,1.7,146.8,1.7z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleUnderscore);
export default __webpack_public_path__ + "static/media/title_underscore.a53af228af9ece63073e2365164673aa.svg";
export { ForwardRef as ReactComponent };